import { Link, useLocation } from "react-router-dom";

const TABS: { to: string; label: string; matcher: (p: string) => boolean }[] = [
  { to: "/", label: "Overview", matcher: (p) => p === "/" },
  { to: "/history", label: "Incidents", matcher: (p) => p.startsWith("/history") },
  { to: "/uptime", label: "Uptime", matcher: (p) => p.startsWith("/uptime") },
  { to: "/changelog", label: "Changelog", matcher: (p) => p.startsWith("/changelog") },
];

export function StatusTabs(): JSX.Element {
  const { pathname } = useLocation();
  return (
    <nav
      className="mb-6 flex items-center gap-1 border-b border-white/[0.07] no-print"
      aria-label="Status sections"
    >
      {TABS.map((t) => {
        const active = t.matcher(pathname);
        return (
          <Link
            key={t.to}
            to={t.to}
            aria-current={active ? "page" : undefined}
            className={`-mb-px border-b-2 px-4 py-2 text-sm font-medium transition-colors ${
              active
                ? "border-dr-blue text-dr-heading"
                : "border-transparent text-text-secondary hover:text-dr-txt"
            }`}
          >
            {t.label}
          </Link>
        );
      })}
    </nav>
  );
}
